import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserTherapistManagement from "./UserTherapistManagement";
import BranchManagement from "./BranchManagement";
import ExpertiseManagement from "./ExpertiseManagement";
import LanguageManagement from "./LanguageManagement";
import AdminSideBar from "../../common/AdminSideBar/AdminSideBar";

const AdminSettings = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
        <div className="md:shrink-0 md:mr-6">
          <AdminSideBar />
        </div>
        <div className="flex-1 p-4 md:p-6 lg:p-8">
          <Box
            p={{ xs: 2, md: 3 }}
            sx={{ maxWidth: 1100, mx: "auto", width: "100%" }}
          >
            <Typography variant="h4" mb={3}>
              Settings
            </Typography>
            <Box sx={{ overflowX: "auto" }}>
              <Tabs
                value={tabIndex}
                onChange={(e, newValue) => setTabIndex(newValue)}
                variant="fullWidth"
                scrollButtons={false}
                sx={{
                  minHeight: 0,
                  "& .MuiTabs-flexContainer": { gap: { xs: 1, md: 2 } },
                  "& .MuiTab-root": {
                    minHeight: 0,
                    minWidth: 0,
                    paddingX: { xs: 1, md: 2 },
                    paddingY: { xs: 1, md: 1.5 },
                    fontSize: { xs: 12, md: 14 },
                    textTransform: "none",
                  },
                }}
              >
                <Tab label="User / Therapist Management" />
                <Tab label="Branch Management" />
                <Tab label="Expertise Management" />
                <Tab label="Language Management" />
              </Tabs>
            </Box>

            <Box mt={3}>
              {tabIndex === 0 && <UserTherapistManagement />}
              {tabIndex === 1 && <BranchManagement />}
              {tabIndex === 2 && <ExpertiseManagement />}
              {tabIndex === 3 && <LanguageManagement />}
            </Box>
          </Box>
          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </div>
    </>
  );
};

export default AdminSettings;
